export default __webpack_public_path__ + "static/media/openapi.a620f51b.yaml";